import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/elderly-people-holding-health-icons_53876-66138.jpg';

function SeniorHealthWellness() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Senior Health and Wellness Programs" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Senior Health and Wellness Programs</h4>
              <p>
                This sub-department focuses on providing health and wellness resources tailored to the needs of the senior population.<br />
                Programs include preventive care, fitness classes, and health screenings to promote overall well-being among seniors.<br /><br />
                Our goal is to support seniors in maintaining an active and healthy lifestyle, ensuring their physical and mental well-being.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Preventive Health Screenings</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Fitness and Wellness Programs</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Chronic Disease Management Support</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to improving the health and wellness of our senior citizens by providing accessible and effective programs that enhance their quality of life.
              </p>
            </div>
            <div>
              <Link to="/department/senior-services">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default SeniorHealthWellness;
